import { render, staticRenderFns } from "./v-camera-device.vue?vue&type=template&id=e89ba19e&scoped=true&"
import script from "./v-camera-device.vue?vue&type=script&lang=js&"
export * from "./v-camera-device.vue?vue&type=script&lang=js&"
import style0 from "./v-camera-device.vue?vue&type=style&index=0&id=e89ba19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89ba19e",
  null
  
)

export default component.exports